import { cn } from "@/lib/utils";

/**
 * Logo Umbo — bouclier métallique (image détourée, nette sur fond clair comme navy)
 * + wordmark « UMBO » et baseline « Cybersécurité & Services IT » en texte (net à toute
 * taille, couleurs adaptatives). Reproduit le lockup fourni par la marque.
 * variant="light" : sur fond clair (header). variant="dark" : sur fond navy (footer).
 */
export const Logo = ({
  variant = "light",
  className = "",
  markClassName = "h-9 sm:h-10",
  textClassName = "text-xl sm:text-2xl",
}) => {
  const dark = variant === "dark";
  return (
    <span
      className={cn("inline-flex items-center gap-2.5 sm:gap-3", className)}
      aria-label="Umbo — Cybersécurité & Services IT"
    >
      <img
        src="/umbo-shield.webp"
        alt=""
        aria-hidden="true"
        draggable="false"
        className={cn("w-auto shrink-0 select-none", markClassName)}
      />
      <span
        aria-hidden="true"
        className={cn("w-px self-stretch my-1 rounded-full", dark ? "bg-white/25" : "bg-navy/20")}
      />
      <span className="flex flex-col justify-center leading-none">
        <span
          className={cn(
            "font-display font-bold tracking-[0.18em] leading-none",
            textClassName,
            dark ? "text-white" : "text-navy"
          )}
        >
          UMBO
        </span>
        <span
          className={cn(
            "mt-1 font-display font-semibold uppercase tracking-[0.14em] leading-none whitespace-nowrap text-[8px] sm:text-[9px]",
            dark ? "text-[#5fa8e8]" : "text-[#126dc6]"
          )}
        >
          Cybersécurité &amp; Services IT
        </span>
      </span>
    </span>
  );
};
